export default __webpack_public_path__ + "static/media/maroc.508decd6.svg";